import React from "react";

const TicTocSvg = () => {
	return (
		<svg
			width="16"
			height="18"
			viewBox="0 0 16 18"
			fill="white"
			className="fill-white dark:fill-darkCardBg"
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>Tictoc</title>
			<path d="M12.6 2.82C11.9166 2.03953 11.5399 1.0374 11.54 0H8.45V12.4C8.42667 13.0712 8.14352 13.7071 7.66031 14.1735C7.1771 14.6399 6.5316 14.9004 5.86 14.9C4.44 14.9 3.26 13.74 3.26 12.3C3.26 10.58 4.92 9.29 6.63 9.82V6.66C3.18 6.2 0.160004 8.88 0.160004 12.3C0.160004 15.63 2.92 18 5.85 18C8.99 18 11.54 15.45 11.54 12.3V6.01C12.793 6.90985 14.2974 7.39265 15.84 7.39V4.3C15.84 4.3 13.96 4.39 12.6 2.82Z" />
		</svg>
	);
};

export default TicTocSvg;
